(function () {
  if (customElements.get('pyk-collection-scroll')) return;

  class CollectionScroll extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.grid = this.section.querySelector('.collection__results product-list');
      this.pagination = this.querySelector('nav');
      this.next = this.pagination && this.pagination.querySelector('[rel="next"]');
      if (!this.grid || !this.next) return;
      this.events = new AbortController();
      this.loaded = new Set();
      this.button = document.createElement('button');
      this.button.type = 'button';
      this.button.className = 'button';
      this.button.textContent = 'Load more';
      this.status = document.createElement('p');
      this.status.setAttribute('role', 'status');
      this.status.setAttribute('aria-live', 'polite');
      this.status.style.marginBlock = '12px';
      this.style.display = 'block';
      this.style.textAlign = 'center';
      this.append(this.button, this.status);
      this.pagination.hidden = true;
      this.button.addEventListener('click', () => this.load(), { signal: this.events.signal });
      document.addEventListener('facet:update', (event) => {
        if (event.target.closest('.shopify-section') === this.section) {
          this.cancelled = true;
          if (this.request) this.request.abort();
          if (this.observer) this.observer.disconnect();
        }
      }, { signal: this.events.signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) this.load();
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);
      }
    }

    async load() {
      if (this.busy || this.cancelled || !this.next || !this.isConnected) return;
      const url = new URL(this.next.getAttribute('href'), window.location.href);
      if (url.origin !== window.location.origin || this.loaded.has(url.href)) return;
      url.searchParams.set('section_id', this.section.id.replace('shopify-section-', ''));
      this.busy = true;
      this.button.disabled = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Loading more products…';
      this.request = new AbortController();
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Unable to load products');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = page.getElementById(this.section.id);
        const grid = section && section.querySelector('.collection__results product-list');
        if (!grid || !grid.children.length) throw new Error('Missing product grid');
        if (this.cancelled || !this.isConnected) return;
        const count = grid.querySelectorAll('product-card, pyk-product-card').length;
        const fragment = document.createDocumentFragment();
        Array.from(grid.children).forEach((child) => {
          if (child.id && this.section.querySelector('#' + CSS.escape(child.id))) return;
          const productId = child.dataset.productId;
          if (productId && this.grid.querySelector('[data-product-id="' + CSS.escape(productId) + '"]')) return;
          fragment.append(document.importNode(child, true));
        });
        this.grid.append(fragment);
        this.loaded.add(new URL(this.next.getAttribute('href'), window.location.href).href);
        this.next = section.querySelector('.collection__pagination [rel="next"]');
        this.status.textContent = this.next ? count + ' more products loaded.' : 'All products loaded.';
        this.button.hidden = !this.next;
        if (!this.next && this.observer) this.observer.disconnect();
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.status.textContent = 'Could not load more products. Please try again.';
          if (this.observer) this.observer.disconnect();
        }
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.grid.removeAttribute('aria-busy');
      }
    }

    disconnectedCallback() {
      if (this.events) this.events.abort();
      if (this.request) this.request.abort();
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('pyk-collection-scroll', CollectionScroll);
})();
